import React from 'react'

export const NotImplemented: React.FC = () => {
  return (
    <div>
      <p>Not yet implemented...</p>
    </div>
  )
}

export default NotImplemented
